import { AfterViewInit, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { ComponentModel } from '../../../services/actions/models/field.model';
import { UntypedFormGroup } from '@angular/forms';
import { ActionConfigInterface, Group } from '../../../services/actions/interfaces/action-config.interface';
import { ControlDynamicComponent } from '@platform500services/p500-ui-kit';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { Observable } from 'rxjs';

@Component({
  selector: 'gtd-group-form',
  templateUrl: './group-form.component.html',
})
@DestroySubscribers()
export class GroupFormComponent implements AfterViewInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() groups: Group[];
  @Input() components: Map<string, ComponentModel['component']>;
  @Input() componentsSettings: Map<string, ComponentModel['settings']>;
  @Input() dependHideFields: Record<string, Observable<boolean>>;
  @Input() actionConfig: ActionConfigInterface;
  @ViewChildren('dynamic') private dynamicList: QueryList<ControlDynamicComponent<any>>;
  private subscribers: any = {};

  ngAfterViewInit(): void {
    this.subscribers.formChanges = this.formGroup.valueChanges.subscribe(() => {
      this.dynamicList?.forEach((component: ControlDynamicComponent<any>) => {
        component?.componentRef?.changeDetectorRef?.markForCheck();
      });
    });
  }
}
